import type { GraphBatchCompiler, GraphBatchEvaluator } from './contracts';

type GraphBatchCapabilities = {
  compiler: GraphBatchCompiler;
  evaluator: GraphBatchEvaluator;
};

/**
 * Stable delegates for the long-lived runner whose implementations can follow
 * the latest React render.
 */
export const createGraphBatchCapabilities = (
  initial: GraphBatchCapabilities,
) => {
  let current = initial;

  return {
    compiler: {
      compileNode: (args) => current.compiler.compileNode(args),
    } satisfies GraphBatchCompiler,
    evaluator: {
      evaluateWave: (args) => current.evaluator.evaluateWave(args),
    } satisfies GraphBatchEvaluator,
    update: (next: GraphBatchCapabilities) => {
      current = next;
    },
  };
};
